const $menus = $('[data-toggle="ui-menu"]');

$menus.each(function initializeMenu() {
    const $currentMenu = $(this);
    const $currentNavigation = $currentMenu.find('.ui-c-menu__navigations');

    $currentNavigation.menuAim({
        activate: (row) => {
            const $row = $(row);

            $row.addClass('is-active--mega-dropdown')
                .trigger('ui.activate');
        },
        deactivate: (row) => {
            const $row = $(row);

            $row.removeClass('is-active--mega-dropdown')
                .trigger('ui.deactivate');
        },
        exitMenu: () => true,
    });

    // JavaScript works fine, remove CSS approach.
    $currentMenu.removeClass('ui-c-menu--css')
        .addClass('ui-c-menu--menu-aim');
});



// WEBPACK FOOTER //
// ./src/js/components/ui-c-menu.js